import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import { delayWhen } from 'rxjs/operators';
import { AppGenFormbuilderService } from '../service/app-gen-formbuilder.service';
import { AppgenAuditService } from '../service/app-gen-audit.service';

@Component({
  selector: 'app-attribute-dialog',
  templateUrl: './attribute-dialog.component.html',
  styleUrls: ['./attribute-dialog.component.scss'],
})
export class AttributeDialogComponent implements OnInit {
  attributeJ: any = {};
  expForm: FormGroup = new FormGroup({});
  @Output() onSaveEmit = new EventEmitter<any>();

  dataFromRole: any;
  dataFromField: any;
  dataFromRule: any;
  dataFromEvent: any;
  dataFromTable: any;
  dataFromValidation: any;
  dependentConfigData: any;

  deletedDataFromEvent: any = [];
  deletedDataFromRule: any = [];
  deletedDataFromRole: any = [];
  deletedDataFromTable: any = [];
  deletedDataFromValidation: any = [];
  deletedDataFromDependentConfig: any = [];
  deletedChildOutPutDataList: any = [];
  deletedFormField: any = [];
  selectedIndex = 0;
  roleComponentList: any = [];

  isFieldSaved: boolean;
  isRuleSaved: boolean;
  isTableSaved: boolean;
  isRoleSaved: boolean;
  isEventSaved: boolean;
  isValidationSaved: boolean;
  audit: any[] = [];
  constructor(
    private dialogRef: MatDialogRef<AttributeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilderService: AppGenFormbuilderService,
    private auditService: AppgenAuditService
  ) {}

  ngOnInit(): void {}
  getKeys(map: any) {
    if (map) return Object.keys(map);
  }
  onTabChanged($event) {
    this.selectedIndex = $event.index;
  }

  getDataFromRole($event) {
    this.isRoleSaved = $event.isRoleSaved;
    this.deletedDataFromRole = $event.deletedRoleData;
    this.roleComponentList = $event.componentList;
    // this.dataFromRole = $event.roleConfigurationData;
    // this.data.attributeJsonValue.roleConfiguration = this.dataFromRole;
    // AUDIT STARTS
    let roleAudit = this.auditService.roleAudit(
      JSON.stringify($event.rows),
      this.formBuilderService.isDraggedFromPalette,
      this.formBuilderService.jsonDataRaw
    );
    this.audit = [roleAudit];
  }
  getDataFromField($event) {
    this.isEventSaved = $event.isFieldSaved;
    this.dataFromField = $event.attributeJ;
    this.dependentConfigData = $event.dependent;
    this.deletedFormField = $event.containerConfig;
    this.getKeys(this.dataFromField).forEach((attributeName) => {
      this.data.attributeJsonValue[attributeName] = this.dataFromField[
        attributeName
      ];
    });

    if (this.dependentConfigData.length != 0)
      this.data.attributeJsonValue.dependentConfiguration = this.dependentConfigData;

    // AUDIT STARTS
    let fieldAudit = this.auditService.fieldAudit(
      $event,
      this.formBuilderService.isDraggedFromPalette,
      this.formBuilderService.jsonDataRaw
    );
    this.audit = [fieldAudit];
    // this.formBuilderService.auditData.push([this.audit])
    console.log('audit', this.audit);
  }
  getDataFromRule($event) {
    this.isRuleSaved = $event.isRuleSaved;
    this.deletedDataFromRule = $event.deletedRuleData;
    this.dataFromRule = $event.ruleConfigurationData;

    this.deletedChildOutPutDataList = $event.childOutPutRuleData;
    this.data.attributeJsonValue.ruleConfiguration = this.dataFromRule;

    // AUDIT STARTS
    let eventAudit = this.auditService.ruleAudit(
      JSON.stringify(this.dataFromRule),
      this.formBuilderService.isDraggedFromPalette,
      this.formBuilderService.jsonDataRaw
    );
    this.audit = [eventAudit];
    // console.log('audit', audit)
  }

  getDataFromEvent($event) {
    this.isEventSaved = $event.isEventSaved;
    this.deletedDataFromEvent = $event.deletedEventData;
    this.dataFromEvent = $event.eventConfigurationData;
    this.data.attributeJsonValue.eventConfiguration = this.dataFromEvent;
    // AUDIT STARTS
    let eventAudit = this.auditService.eventAudit(
      JSON.stringify(this.dataFromEvent),
      this.formBuilderService.isDraggedFromPalette,
      this.formBuilderService.jsonDataRaw
    );
    this.audit = [eventAudit];
    // console.log('audit', audit)
  }
  getDataFromValidation($event) {
    this.isValidationSaved = $event.isValidationSaved;
    this.deletedDataFromValidation = $event.deletedvalidationData;
    this.dataFromValidation = $event.validationConfigurationData;
    this.data.attributeJsonValue.validations = this.dataFromValidation;
    // AUDIT STARTS
    let validateAudit = this.auditService.validateAudit(
      JSON.stringify(this.dataFromValidation),
      this.formBuilderService.isDraggedFromPalette,
      this.formBuilderService.jsonDataRaw
    );
    this.audit = [validateAudit];
  }

  getDataFromTable($event) {
    this.isTableSaved = $event.isTableSaved;
    this.deletedDataFromTable = $event.deletedTableData;

    this.dataFromTable = $event.tableConfigurationData;
    console.log('in attribute---', this.dataFromTable);

    this.data.attributeJsonValue.fieldColumnConfig = this.dataFromTable;
    console.log(
      'in attribute---',
      this.data.attributeJsonValue.fieldColumnConfig
    );
    // AUDIT STARTS
    let tableAudit = this.auditService.TableAudit(
      JSON.stringify(this.dataFromTable),
      this.formBuilderService.isDraggedFromPalette,
      this.formBuilderService.jsonDataRaw
    );
    this.audit = [tableAudit];
    // console.log('audit', audit)
  }

  removeExtraFields() {
    if (this.data.attributeJsonValue.components) {
      this.getKeys(this.data.attributeJsonValue.components).forEach((comp) => {
        let compRole = this.data.attributeJsonValue.components[comp]
          .roleConfiguration;

        for (let key in compRole) {
          delete compRole[key].permission;
          delete compRole[key].role;

          if (compRole[key].componentName) {
            delete compRole[key].componentName;
            delete compRole[key].componentPosition;
          }
        }
      });
    }
    if (
      this.data.attributeJsonValue.roleConfiguration != null &&
      this.data.attributeJsonValue.roleConfiguration != undefined
    ) {
      for (let key in this.data.attributeJsonValue.roleConfiguration) {
        delete this.data.attributeJsonValue.roleConfiguration[key].permission;
        delete this.data.attributeJsonValue.roleConfiguration[key].role;

        if (this.data.attributeJsonValue.roleConfiguration[key].componentName) {
          delete this.data.attributeJsonValue.roleConfiguration[key]
            .componentName;
          delete this.data.attributeJsonValue.roleConfiguration[key]
            .componentPosition;
        }
      }
    }
    if (
      this.data.attributeJsonValue.fieldColumnConfig != null &&
      this.data.attributeJsonValue.fieldColumnConfig != undefined
    ) {
      for (let key in this.data.attributeJsonValue.fieldColumnConfig) {
        if (
          this.data.attributeJsonValue.fieldColumnConfig[key].loadCriteriaName
        ) {
          delete this.data.attributeJsonValue.fieldColumnConfig[key]
            .loadCriteriaName;
        }
      }
    }
    if (
      this.data.attributeJsonValue.validations != null &&
      this.data.attributeJsonValue.validations != undefined
    ) {
      for (let key in this.data.attributeJsonValue.validations) {
        delete this.data.attributeJsonValue.validations[key].validationName;
        delete this.data.attributeJsonValue.validations[key].componentName;
      }
    }
    if (
      this.data.attributeJsonValue.ruleConfiguration != null &&
      this.data.attributeJsonValue.ruleConfiguration != undefined
    ) {
      for (let key in this.data.attributeJsonValue.ruleConfiguration) {
        if (this.data.attributeJsonValue.ruleConfiguration[key].cmpFormName) {
          delete this.data.attributeJsonValue.ruleConfiguration[key]
            .cmpFormName;
        }
        if (
          this.data.attributeJsonValue.ruleConfiguration[key]
            .otherCmpFormName ||
          this.data.attributeJsonValue.ruleConfiguration[key]
            .otherCmpFormName == null
        ) {
          delete this.data.attributeJsonValue.ruleConfiguration[key]
            .otherCmpFormName;
        }
        if (this.data.attributeJsonValue.ruleConfiguration[key].valueText) {
          delete this.data.attributeJsonValue.ruleConfiguration[key].valueText;
        }
        if (this.data.attributeJsonValue.ruleConfiguration[key].operatorV) {
          delete this.data.attributeJsonValue.ruleConfiguration[key].operatorV;
        }
        for (let rule in this.data.attributeJsonValue.ruleConfiguration[key]
          .cmnVisibilityRuleOutputList) {
          if (
            this.data.attributeJsonValue.ruleConfiguration[key]
              .cmnVisibilityRuleOutputList[rule].dependCmpFormName
          ) {
            delete this.data.attributeJsonValue.ruleConfiguration[key]
              .cmnVisibilityRuleOutputList[rule].dependCmpFormName;
          }

          delete this.data.attributeJsonValue.ruleConfiguration[key]
            .cmnVisibilityRuleOutputList[rule].opValueText;

          delete this.data.attributeJsonValue.ruleConfiguration[key]
            .cmnVisibilityRuleOutputList[rule].loadComboName;

          // if (
          //   this.data.attributeJsonValue.ruleConfiguration[key]
          //     .cmnVisibilityRuleOutputList[rule].successFail
          // ){
          //   delete this.data.attributeJsonValue.ruleConfiguration[key]
          //     .cmnVisibilityRuleOutputList[rule].successFail;
          // }
        }
      }
    }
    if (
      this.data.attributeJsonValue.eventConfiguration != null &&
      this.data.attributeJsonValue.eventConfiguration != undefined
    ) {
      for (let key in this.data.attributeJsonValue.eventConfiguration) {
        delete this.data.attributeJsonValue.eventConfiguration[key].eventName;
        delete this.data.attributeJsonValue.eventConfiguration[key]
          .executionTypeName;
        delete this.data.attributeJsonValue.eventConfiguration[key].entityName;
      }
    }
  }
  onSave() {
    if (this.deletedFormField != null && this.deletedFormField.length != 0) {
      this.deletedFormField?.forEach((element) => {
        this.formBuilderService.deleteAllObj(element?.components);
      });
      this.data.attributeJsonValue.components.push(...this.deletedFormField);
    }
    if (
      this.deletedDataFromEvent != undefined &&
      this.deletedDataFromEvent.length != 0
    ) {
      this.data.attributeJsonValue.eventConfiguration.push(
        ...this.deletedDataFromEvent
      );
    }
    if (
      this.deletedDataFromRule != undefined &&
      this.deletedDataFromRule.length != 0
    ) {
      this.data.attributeJsonValue.ruleConfiguration.push(
        ...this.deletedDataFromRule
      );
      if (
        this.deletedDataFromRule.length != 0 &&
        this.data?.attributeJsonValue?.eventConfiguration.length != 0
      ) {
        this.getKeys(this.deletedDataFromRule).forEach((comp1) => {
          let ruleEvent = this.deletedDataFromRule[comp1];
          this.getKeys(this.data.attributeJsonValue.eventConfiguration).forEach(
            (comp) => {
              let eventData = this.data.attributeJsonValue.eventConfiguration[
                comp
              ];
              if (
                ruleEvent?.cmpRuleMpgId == eventData?.ruleSubNotiId &&
                eventData?.ruleSubNotiId
              ) {
                eventData.activeFlag = 0;
                //
              }
            }
          );
        });
      }
    }
    if (
      this.deletedDataFromValidation != undefined &&
      this.deletedDataFromValidation.length != 0
    ) {
      this.data.attributeJsonValue.validations.push(
        ...this.deletedDataFromValidation
      );
    }
    if (
      this.deletedChildOutPutDataList != undefined &&
      this.deletedChildOutPutDataList.length != 0
    ) {
      for (let key in this.deletedChildOutPutDataList) {
        let parent = this.data.attributeJsonValue.ruleConfiguration.find(
          (o) => o.cmpRuleMpgId == this.deletedChildOutPutDataList[key].parentId
        );
        if (parent != null && parent != undefined) {
          parent.cmnVisibilityRuleOutputList.push(
            ...this.deletedChildOutPutDataList[key].child
          );
        }
      }
    }
    if (
      this.deletedDataFromRole != undefined &&
      this.deletedDataFromRole.length != 0
    ) {
      if (
        this.data.attributeJsonValue?.components != undefined &&
        this.data.attributeJsonValue?.components.length != 0
      ) {
        let index: any;

        this.getKeys(this.roleComponentList).forEach((element) => {
          console.log(this.roleComponentList[element], element);
          if (this.roleComponentList[element].position != 'select') {
            index = element;
            this.data.attributeJsonValue.components[
              this.roleComponentList[index].position
            ].roleConfiguration.push(
              ...this.deletedDataFromRole.filter(
                (x) =>
                  x.componentPosition ==
                  this.roleComponentList[element].position
              )
            );
          }

          // this.data.attributeJsonValue.components[
          //   this.deletedDataFromRole[index].componentPosition
          // ].roleConfiguration.push(...deletedChildArr);
        });

        let deletedParentArr: any = [];
        deletedParentArr = this.deletedDataFromRole.filter(
          (x) => x.componentPosition == 'select'
        );
        this.data.attributeJsonValue.roleConfiguration.push(
          ...deletedParentArr
        );
      } else {
        this.data.attributeJsonValue.roleConfiguration.push(
          ...this.deletedDataFromRole
        );
      }

      // this.data.attributeJsonValue.roleConfiguration.push(
      //   ...this.deletedDataFromRole
      // );
    }

    if (
      this.deletedDataFromTable != undefined &&
      this.deletedDataFromTable.length != 0
    ) {
      this.data.attributeJsonValue.fieldColumnConfig.push(
        ...this.deletedDataFromTable
      );
    }

    // let result2 = this.data.attrData.find(
    //   (o) => o.name === 'comboMap'
    // );
    // if(result2?.defaultValue1!= undefined && result2?.defaultValue1! ){
    //   delete result2?.defaultValue1;
    // }

    this.getKeys(this.data.attrData).forEach((attributeName) => {
      let defalutVal = this.data.attrData[attributeName]?.defaultValue1;
      if (defalutVal != undefined && defalutVal != null) {
        delete this.data.attrData[attributeName]?.defaultValue1;
      }
    });
    this.removeExtraFields();
    this.data.attributeJsonValue.isAddUpdate = 'update';
    if (this.data.attributeJsonValue.comboMapValues) {
      this.data.attributeJsonValue.comboMapValues = [];
    }
    let dataToSend = {
      attributeJ: this.data.attributeJsonValue,
      currentIndex: this.data.currentIndex,
      auditData: this.audit,
    };
    this.dialogRef.close(dataToSend);
    console.log('final', this.data);
    this.formBuilderService.isDraggedFromPalette = false;
    // RESET AUDITV2
    this.auditService.resetAuditV2();
  }

  onCancel() {
    this.removeExtraFields();
  }
}
